import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import ListSubheader from '@material-ui/core/ListSubheader';

const styles = theme => ({
root: {
  display: 'flex',
   flexWrap: 'wrap',
   justifyContent: 'space-around',
   overflow: 'hidden',
},

gridList: {
    width: 1000,

  },
  icon:{
    width: '40%',
    padding: '1em',
  }
});

class Contact extends Component{
  constructor(){
    super();
    this.state={
      newMessage:{
        full_name:'',
        email:'',
        subject:'',
        message:''
      },
      newIcon:[]
    }
  }

componentDidMount(){
  fetch('/API/icons.json')
  .then(res => res.json())
  .then(data => {
    let icons = data.map(el=> el)
    this.setState({ newIcon:icons })
  })

}


  render (){
    const { classes } = this.props;
    const {newIcon} = this.state
    return (
      <Grid container className={classes.root}>

            <GridList cellHeight={150} cols={5} className={classes.gridList}>
            <GridListTile key="Subheader" cols={5} style={{ height: 'auto'}}>
               <ListSubheader component="div" style={{ paddingBottom: '1em', fontSize:'3em' }}>Get In Touch</ListSubheader>
             </GridListTile>
            {newIcon.map(icon => (
              <GridListTile key={icon.id} >
                <a href={icon.url} target='blank' className='icons'>
                  <img src={icon.img} alt={icon.title} className={classes.icon}/>
                </a>
              </GridListTile>
            ))}
            </GridList>

      </Grid>
    )
  }
}

export default withStyles(styles)(Contact)
